import { colors } from '../foundation';
import More from '../svg/More';

type Props = {
  inverse: boolean;
};

const MoreIndicator = ({ inverse }: Props) => {
  return (
    <div className={`flex h-[36px] w-[36px] items-center justify-center `}>
      <More color={inverse ? colors.monochrome.inverse[6] : colors.monochrome[6]} />
    </div>
  );
};
export default MoreIndicator;
